import { Dispatch } from "redux";
import AuthClient from "../clients/AuthClient";
import LoginConfig from "../interfaces/auth/LoginConfig";
import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import LoginResponse from "../interfaces/auth/LoginResponse";
import ThunkDispatch from "../interfaces/ThunkDispatch";
import ThunkAction from "../interfaces/ThunkAction";
import LoginBootstrap from "../interfaces/auth/LoginBootstrap";
import HttpUtil from "../utils/HttpUtil";
import ErrorMessageEnum from "../enums/ErrorMessageEnum";

const authClient = new AuthClient();

// ------------------------- [ Action Creators ] -------------------------

const setLoginBootstrap = (bootstrap: LoginBootstrap): Action => ({
    type: ActionTypeEnum.AUTH_LOGIN_BOOTSTRAP_SET,
    bootstrap,
});

// ------------------------- [ Thunks ] -------------------------

export const loadLoginBootstrap = (): ThunkAction<Promise<LoginBootstrap>> => (
    async (dispatch: Dispatch) => {
        const response = await authClient.getBootstrap();
        const { data } = response;

        dispatch(setLoginBootstrap(data));

        return data;
    }
);

export const login = (login: LoginConfig): ThunkAction<Promise<LoginResponse>> => (
    async (dispatch: ThunkDispatch) => {
        const response = await authClient.login(login).catch((error) => {
            HttpUtil.logErroneousRequest("Failed to login due to unexpected error.", error);
            throw new Error(ErrorMessageEnum.GENERIC);
        });

        const { data } = response;

        // The API should _always_ return a new login bootstrap. CSRF tokens are only valid once, and the CAPTCHA requirement can change between requests.
        if (data.csrf && typeof data.captcha === "boolean") {
            dispatch(setLoginBootstrap(data));
        }
        if (!data.success) {
            console.error("Login returned unsuccessful response.", data);
            throw new Error(data.error ?? ErrorMessageEnum.GENERIC);
        }

        return data;
    }
);
